import Step from './step';
import QuickNav from './quickNav';
import QuickTypeNav from './quickTypeNav';
import Tabs from './tabs';
export default {
  Step,
  QuickNav,
  QuickTypeNav,
  Tabs
};
